<template>
    
    <ul style=" list-style-type: none;padding: 0;">                                  
        <router-link to="/contacter-nous"><li class="m-3 text-primary" style="cursor: pointer;">Contactez-nous</li></router-link> 
    </ul>

</template>

<script>
export default ({
    name: "footer-ATLAS"
})
</script>


